<template>
  <modal-wrapper :visible="visible" v-on="$listeners">
    <template slot="content">
      <div class="font-32-40 text">
        <span class="text__blue">{{ content.titleOne }}</span>

        {{ content.titleTwo }}
      </div>

      <div class="font-18-24 description">{{ content.description }}</div>

      <lead-form v-on="$listeners" />
    </template>
  </modal-wrapper>
</template>

<script>
import { formBlockConsultation } from '@/content/data'
import LeadForm from '@/components/common/Form/LeadForm'
import ModalWrapper from '@/components/common/Modals/ModalWrapper'

export default {
  name: 'ModalFormConsultation',
  components: { ModalWrapper, LeadForm },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: formBlockConsultation,
    }
  },
}
</script>

<style lang="sass" scoped>
.description
  margin-top: .8rem
  margin-bottom: 2.3rem

.font-subtitle
  @media (max-width: 1279px)
    width: 80%

::v-deep .form-callback
  display: flex
  flex-direction: column
  &__input
    margin-bottom: 2rem

  &__button
    height: 5rem
    background: $buttonPrimary
    color: $textWhite
    &:hover
      background: $buttonHover
    &:active
      background: $buttonClicked

    &.disabled
      background: $buttonDisabled
      cursor: not-allowed
      color: #B3B8C0
      &:hover
        background: $buttonDisabled
      &:active
        background: $buttonDisabled

  &__checkbox
    margin-bottom: 3.3rem

::v-deep .input
  background: #F6F8F8
  &__content-input
    background: #F6F8F8

.text
  font-weight: 500
  color: #00130A
  &__blue
    color: $buttonPrimary
</style>
